import { i18n_t as $t } from '@/utils/i18n';

export function getI18nKeyForMetadataDisplayName (group, key, kind) {
    if (group === 'auto') {
        const autoMetadataTranslations = {
            id: kind === 'visitor' ? $t('Visitor ID') : $t('Account ID'),
            accountid: $t('Account ID'),
            accountids: $t('Account IDs'),
            createdat: $t('Created At'),
            firstvisit: $t('First Visit'),
            firstanonymousvisit: $t('First Mapped Anonymous Visit'),
            firstidentifiedvisit: $t('First Identified Visit'),
            lastvisit: $t('Last Visit'),
            lastbrowsername: $t('Most recent browser name'),
            lastbrowserversion: $t('Most recent browser version'),
            lastoperatingsystem: $t('Most recent operating system'),
            lastservername: $t('Most recent server name'),
            identifiedvisitorat: $t('Visitor identified at'),
            identifiedvisitorid: $t('Identified visitor ID'),
        };

        return autoMetadataTranslations[key];
    }
}

export function i18nizeMetadata (metadataSet, kind = 'visitor', group = 'auto') {
    if (Array.isArray(metadataSet)) {
        metadataSet = metadataSet.reduce((acc, item) => {
            acc[item.field] = item;

            return acc;
        }, {});
    }

    const transformedMetadata = { ...metadataSet };
    Object.entries(transformedMetadata).forEach(([key, value]) => {
        if (value) {
            transformedMetadata[key] = {
                ...value,
                DisplayName: getI18nKeyForMetadataDisplayName(group, key, kind) || transformedMetadata[key].DisplayName,
            };
        }
    });

    return transformedMetadata;
}
